import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgZincSoapBarGlyph from './svgs/ZincSoapBarGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var zincSoapBarGlyph = (props => useIcon(SvgZincSoapBarGlyph, SvgZincSoapBarGlyph, props));

export { zincSoapBarGlyph as default };
